export const DECLINE = "DECLINE";
export const TIKET_DETAILS = "TIKET_DETAILS";
export const WORKERS = "WORKERS";
